import { Typography } from '@mui/material';
import { Column, usePagination, useRowSelect, useSortBy, useTable } from 'react-table';
import { AdditionalQuoteDocumentationItem } from 'shared/types';
import { additionalQuoteDocumentationTableColumns } from './columns/additional-quote-documentation-columns';

const defaultColumn: Partial<Column<AdditionalQuoteDocumentationItem>> = {
  Filter: () => null,
  Cell: ({ value = '' }) => <Typography variant='body2'>{value}</Typography>,
  disableFilters: true,
  width: 150,
  minWidth: 150,
  maxWidth: 150,
  align: 'inherit',
};

export function useAdditionalQuoteDocumentationTableInstance(data: AdditionalQuoteDocumentationItem[]) {
  return useTable<AdditionalQuoteDocumentationItem>(
    {
      columns: additionalQuoteDocumentationTableColumns,
      data,
      initialState: { pageSize: 100 },
      defaultColumn,
      autoResetFilters: false,
    },
    useSortBy,
    usePagination,
    useRowSelect
  );
}
